import * as React from "react";
import MoreOverlay from "./moreOverlay";
import MultiMedia from "./multiMedia";
import getFirstVideoIndex from "../helper/getFirstVideoIndex";
// styles

const styles = require("./squarePlaceholder.scss");

interface ISquarePlaceholderProps {
  summaryData: Array<
    Vingle.CardContent.ImageContentData | Vingle.CardContent.VideoContentData
  >;
  componentWidth: number;
  componentHeight: number;
}

class SquarePlaceholder extends React.PureComponent<ISquarePlaceholderProps> {
  public render() {
    const { summaryData } = this.props;
    if (summaryData.length === 1) {
      return this.oneImageContainer();
    } else if (summaryData.length === 2) {
      return this.twoImageContainer();
    } else if (summaryData.length === 3) {
      return this.threeImageContainer();
    } else if (summaryData.length === 4) {
      return this.fourImageContainer();
    } else if (summaryData.length === 5) {
      return this.fiveImageContainer();
    } else if (summaryData.length > 5) {
      return this.fiveImageContainer(true);
    } else {
      return null;
    }
  }

  private readonly oneImageContainer = () => {
    const data = this.props.summaryData[0];
    const style = {
      width: this.props.componentWidth,
      height: this.props.componentHeight,
    };

    return (
      <div className={`${styles.typeOne} ${styles.item}`} style={style}>
        <MultiMedia
          data={data}
          width={style.width}
          height={style.height}
          autoPlay={getFirstVideoIndex(this.props.summaryData) === 0}
        />
      </div>
    );
  };

  private readonly twoImageContainer = () => {
    const { summaryData, componentWidth, componentHeight } = this.props;
    const itemStyles = {
      width: componentWidth / 2,
      height: componentHeight,
    };

    return (
      <div
        className={styles.twoImageWrapper}
        style={{
          width: this.props.componentWidth,
          height: this.props.componentHeight,
        }}
      >
        <div
          style={itemStyles}
          className={`${styles.item} ${styles.topLeft} ${styles.bottomLeft}`}
        >
          <MultiMedia
            width={componentWidth / 2}
            height={componentHeight}
            data={summaryData[0]}
            autoPlay={getFirstVideoIndex(summaryData) === 0}
            className={`${styles.topLeft} ${styles.bottomLeft}`}
          />
        </div>
        <div
          style={itemStyles}
          className={`${styles.item} ${styles.marginLeft} ${styles.topRight} ${
            styles.bottomRight
          }`}
        >
          <MultiMedia
            width={componentWidth / 2}
            height={componentHeight}
            data={summaryData[1]}
            autoPlay={getFirstVideoIndex(summaryData) === 1}
            className={`${styles.topRight} ${styles.bottomRight}`}
          />
        </div>
      </div>
    );
  };

  private readonly threeImageContainer = () => {
    const { summaryData, componentWidth, componentHeight } = this.props;

    return (
      <div
        className={styles.threeImageWrapper}
        style={{
          width: this.props.componentWidth,
          height: this.props.componentHeight * 1.2,
        }}
      >
        <div
          className={`${styles.item} ${styles.top} ${styles.marginBottom} ${
            styles.topRight
          } ${styles.topLeft}`}
          style={{
            width: componentWidth,
            height: componentHeight * 0.7,
          }}
        >
          <MultiMedia
            width={componentWidth}
            height={componentHeight * 0.7}
            data={summaryData[0]}
            autoPlay={getFirstVideoIndex(summaryData) === 0}
            className={`${styles.topRight} ${styles.topLeft}`}
          />
        </div>
        <div
          className={`${styles.bottom} ${styles.bottomRight} ${
            styles.bottomLeft
          }`}
        >
          <div
            className={`${styles.item} ${styles.bottomLeft}`}
            style={{
              width: componentWidth / 2,
              height: componentHeight / 2,
            }}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[1]}
              autoPlay={getFirstVideoIndex(summaryData) === 1}
              className={styles.bottomLeft}
            />
          </div>
          <div
            className={`${styles.item} ${styles.marginLeft} ${
              styles.bottomRight
            }`}
            style={{
              width: componentWidth / 2,
              height: componentHeight / 2,
            }}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[2]}
              autoPlay={getFirstVideoIndex(summaryData) === 2}
              className={styles.bottomRight}
            />
          </div>
        </div>
      </div>
    );
  };

  private readonly fourImageContainer = () => {
    const { summaryData, componentWidth, componentHeight } = this.props;
    const itemStyles = {
      width: componentWidth / 2,
      height: componentHeight / 2,
    };

    return (
      <div
        className={styles.fourImageWrapper}
        style={{
          width: this.props.componentWidth,
          height: this.props.componentHeight,
        }}
      >
        <div
          className={`${styles.section} ${styles.marginBottom} ${
            styles.topLeft
          } ${styles.topRight}`}
        >
          <div
            style={itemStyles}
            className={`${styles.item} ${styles.topLeft}`}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[0]}
              autoPlay={getFirstVideoIndex(summaryData) === 0}
              className={styles.topLeft}
            />
          </div>
          <div
            style={itemStyles}
            className={`${styles.item} ${styles.marginLeft} ${styles.topRight}`}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[1]}
              autoPlay={getFirstVideoIndex(summaryData) === 1}
              className={styles.topRight}
            />
          </div>
        </div>
        <div
          className={`${styles.section} ${styles.bottomLeft} ${
            styles.bottomRight
          }`}
        >
          <div
            style={itemStyles}
            className={`${styles.item} ${styles.bottomLeft}`}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[2]}
              autoPlay={getFirstVideoIndex(summaryData) === 2}
              className={styles.bottomLeft}
            />
          </div>
          <div
            style={itemStyles}
            className={`${styles.item} ${styles.marginLeft} ${
              styles.bottomRight
            }`}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[3]}
              autoPlay={getFirstVideoIndex(summaryData) === 3}
              className={styles.bottomRight}
            />
          </div>
        </div>
      </div>
    );
  };

  private readonly fiveImageContainer = (showMore: boolean = false) => {
    const { summaryData, componentWidth, componentHeight } = this.props;
    const topThumbnailStyle = {
      width: componentWidth / 2,
      height: componentHeight / 2,
    };
    const bottomWrapperStyle = {
      width: componentWidth,
      height: componentHeight * 0.33,
    };
    const correctionValue = 0.9;
    const bottomThumbnailStyle = {
      width: componentWidth * 0.33 + correctionValue,
      height: componentHeight * 0.33,
    };

    return (
      <div
        className={styles.fiveImageWrapper}
        style={{
          width: this.props.componentWidth,
          height: this.props.componentHeight * 0.83,
        }}
      >
        <div
          className={`${styles.top} ${styles.marginBottom} ${styles.topLeft} ${
            styles.topRight
          }`}
        >
          <div
            style={topThumbnailStyle}
            className={`${styles.item} ${styles.topLeft}`}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={componentHeight / 2}
              data={summaryData[0]}
              autoPlay={getFirstVideoIndex(summaryData) === 0}
              className={styles.topLeft}
            />
          </div>
          <div
            style={topThumbnailStyle}
            className={`${styles.item} ${styles.marginLeft} ${styles.topRight}`}
          >
            <MultiMedia
              width={componentWidth / 2}
              height={(componentHeight / 3) * 2}
              data={summaryData[1]}
              autoPlay={getFirstVideoIndex(summaryData) === 1}
              className={styles.topRight}
            />
          </div>
        </div>
        <div
          style={bottomWrapperStyle}
          className={`${styles.bottom} ${styles.bottomLeft} ${
            styles.bottomRight
          }`}
        >
          <div
            style={bottomThumbnailStyle}
            className={`${styles.item} ${styles.bottomLeft}`}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[2]}
              autoPlay={getFirstVideoIndex(summaryData) === 2}
              className={styles.bottomLeft}
            />
          </div>
          <div
            style={bottomThumbnailStyle}
            className={`${styles.item} ${styles.marginLeft}`}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[3]}
              autoPlay={getFirstVideoIndex(summaryData) === 3}
            />
          </div>
          <div
            style={bottomThumbnailStyle}
            className={`${styles.item} ${styles.marginLeft} ${
              styles.bottomRight
            }`}
          >
            <MultiMedia
              width={componentWidth / 3}
              height={componentHeight / 3}
              data={summaryData[4]}
              autoPlay={getFirstVideoIndex(summaryData) === 4}
              className={styles.bottomRight}
              hideBadge={showMore}
            />
            {showMore ? (
              <MoreOverlay
                className={`${styles.more} ${styles.bottomRight}`}
                sizeOfRemain={summaryData.length - 4}
              />
            ) : null}
          </div>
        </div>
      </div>
    );
  };
}
export default SquarePlaceholder;
